import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityEntidadesProductivaTramiteChangeFailure,
  entityEntidadesProductivaTramiteChangeRequest,
  entityEntidadesProductivaTramiteChangeSuccess
} from './entidad-productiva-tramite.actions';

import { Update } from '@ngrx/entity';
import { EntidadesProductiva } from '../entity-entidad-productiva/entity-entidades-productiva.model';
import { EntidadesProductivaService } from '../entity-entidad-productiva/entity-entidades-productiva.service';

@Injectable()
export class EntidadesProductivaTramiteEffects {
  // change
  changeRequestEntidadesProductivaTramite = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEntidadesProductivaTramiteChangeRequest),
      switchMap((action) =>
        this.entidadesProductivaService
          .changeEntidadProductiva(action.item)
          .pipe(
            map((item) => {
              //this.router.navigateByUrl('/main/landing')
              const itemUpdate: Update<EntidadesProductiva> = {
                id: item.id,
                changes: {
                  estado: item.estado,
                  exclusivo_comercializacion: item.exclusivo_comercializacion
                }
              };
              return entityEntidadesProductivaTramiteChangeSuccess({
                item: itemUpdate
              });
            }),
            catchError((error) =>
              of(entityEntidadesProductivaTramiteChangeFailure({ error }))
            )
          )
      )
    )
  );

  changeSuccessEntidadesProductivaTramite = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityEntidadesProductivaTramiteChangeSuccess),
        tap((action) => {
          // Fin del tramite
          if (action.item.changes.estado == 2) {
            this.router.navigateByUrl('/tramite/vista-tramites');
          }
        })
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private entidadesProductivaService: EntidadesProductivaService,
    private router: Router
  ) {
    this.entidadesProductivaService.url = environment.apiUrl;
  }
}
